import { LogoutIcon, SaveIcon, TrashIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Panel as Mp4Panel } from './components/Mp4';
import { Panel as MultiplechoicePanel } from './components/Multiplechoice';
import { Panel as OpenQuestionPanel } from './components/Open';
import { Panel as SummaryPanel } from './components/Summary';
import { Panel as InfographicPanel } from './components/infographic';

function Module(props) {
  const { item, setItem } = props;
  if (!item) return null;
  switch (item.type) {
    case 'infographic':
      return <InfographicPanel item={item} setItem={setItem} />;
    case 'multiplechoice':
      return <MultiplechoicePanel item={item} setItem={setItem} />;
    case 'open':
      return <OpenQuestionPanel item={item} setItem={setItem} />;
    case 'mp4':
      return <Mp4Panel item={item} />;
    case 'summary':
      return <SummaryPanel />;
    default:
      throw new Error(`${item.type} is not a valid component type`);
  }
}

Module.propTypes = {
  item: PropTypes.objectOf({
    type: PropTypes.string,
  }).isRequired,
  setItem: PropTypes.func.isRequired,
};

function Panel(props) {
  const { item, setItem, save, deleteCurrenItem, loading } = props;
  const params = useParams();
  const { t } = useTranslation();

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex justify-end gap-4">
        <button
          type="button"
          className="flex gap-4 disabled:bg-gray-400 bg-red-500 hover:bg-red-600 rounded-md text-white px-4 py-2 items-center shadow-sm hover:shadow-md"
          onClick={deleteCurrenItem}
          disabled={loading}
        >
          <TrashIcon className="w-5 h-5" />
          {t('courses.delete_slide')}
        </button>
        <button
          type="button"
          className="flex gap-4 disabled:bg-gray-400 bg-green-500 hover:bg-green-600 rounded-md text-white px-4 py-2 items-center shadow-sm hover:shadow-md"
          onClick={save}
          disabled={loading}
        >
          <SaveIcon className="w-5 h-5" />
          {t('courses.save')}
        </button>
        <Link to={`/courses/${params.courseId}`}>
          <button
            type="button"
            className="flex gap-4 disabled:bg-gray-400 bg-yellow hover:bg-yellow-500 rounded-md text-white px-4 py-2 items-center shadow-sm hover:shadow-md"
            disabled={loading}
          >
            <LogoutIcon className="w-5 h-5" />
            {t('courses.exit_editor')}
          </button>
        </Link>
      </div>
      <Module item={item} setItem={setItem} />
    </div>
  );
}

Panel.propTypes = {
  item: PropTypes.objectOf({}).isRequired,
  setItem: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  deleteCurrenItem: PropTypes.func.isRequired,
};

export default Panel;
